const cluster_id = {
    title: 'Cluster ID',
    text:
        'Cluster identification (ID). Clusters exist for each value chain (Development, Manufacturing, Production, Logistics, Service, Others).'
}

const cluster_name = {
    title: 'Cluster Name',
    text:
        'A cluster refers to a group of technologies gathered around the main technical fields (common factors) that make up the relevant theme in each value chain. Each cluster is a collection of patent applications held by companies belonging to the relevant value chain.\n\nThe cluster name is generated by Generative AI based on the labels of IPCs within the cluster, but it does not guarantee an accurate summary of the technical information of the cluster.'
}

const score_technological_progress = {
    title: 'Score (Technological Progress)',
    text:
        'The cluster score, which can be interpreted as the "degree of technological advancement", is also sometimes referred to as the "technology score". The cluster score is calculated based on the total score of all companies within the relevant cluster, and a higher score indicates a higher degree of technological advancement in that cluster (group of technologies).'
}

const growth_rate_of_score = {
    title: 'Growth Rate of Score',
    text:
        'The growth rate of the cluster score in the most recent three years represents the recent speed of technological advancement in the relevant cluster (group of technologies).\nThe analysis is performed by dividing the time periods based on the patent application year, and the growth rate is calculated as the average of the growth rates of the scores in each period.'
}

const marketability = {
    title: 'Market Expectation',
    text:
        'Calculated by summing the minority investment amounts (including joint venture investments) received by each company within the cluster over the past approximately 10 years, representing the "market attention towards each cluster (group of technologies)".'
}

const market_attention = {
    title: 'Growth Rate of Market Expectation',
    text:
        'Represents the growth rate of Market Expectation over the past three years, indicating the increase in market attention towards the relevant cluster (group of technologies).\nCalculated as the average growth rate of Market Expectation for each period, based on the investment year.'
}

const marketability_startup = {
    title: 'Startup Market Expectation',
    text:
        'Calculated by summing the minority investment amounts (including joint venture investments) received by each startup company within the cluster over the past approximately 10 years, representing the "market attention towards emerging clusters (group of technologies) with startups".'
}

const market_attention_startup = {
    title: 'Growth Rate of Startup Market Expectation',
    text:
        'Represents the growth rate of startup Market Expectation over the past three years, indicating the increase in market attention towards the relevant cluster (group of technologies).\nCalculated as the average growth rate of Market Expectation for each period, based on the investment year.'
}

const ip_code = {
    title: 'IPC Code',
    text:
        'IPC (International Patent Classification) is a classification system for patents established by WIPO (World Intellectual Property Organization). It has a hierarchical structure consisting of sections, classes, subclasses, main groups, and subgroups.'
}

const factor_load_quantity = {
    title: 'Factor Load Quantity',
    text:
        'It represents the degree of influence on the main technical fields (common factors) of the relevant IPC and can also be interpreted as the importance of the IPC in the theme.'
}

const is_important = {
    title: 'Material Patent',
    text: 'A patent is defined as a material patent if it is in the top 5% of citation counts within the same IPC.'
}

const most_frequent_ipc = {
    title: 'Most Frequent IPC',
    text:
        'It represents the most frequently occurring IPC in the patent applications of the relevant company within the relevant cluster, and can be regarded as the main technology held by the company in the cluster.'
}

const score_for_cluster_details = {
    title: 'Score',
    text:
        'This is a company\'s score that can be interpreted as "technological competitiveness". It is sometimes also referred to as "technology score".\nThe cluster score is calculated by summing the scores of all companies within the cluster.'
}

const important_patents_count = {
    title: 'Number of Material Patents',
    text:
        'Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nThis represents the number of material patents a company holds within the relevant cluster.'
}

const important_patent_rate = {
    title: 'Material Patent ratio',
    text:
        'Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nThis represents the ratio of material patents held by a company to the total number of material patents within the relevant cluster of the theme.'
}

const number_of_forward_citations = {
    title: 'Number of Forward Citations',
    text:
        'It represents the number of times the relevant patent application has been cited by the applicant or the patent examiner in other patent documents. The greater the number of citations, the higher the objective importance of that patent application can be considered.'
}

const minority_investment_amount = {
    title: 'Minority Investment Amount [m JPY]',
    text:
        'Represents the total amount of minority investments (including joint venture investments) received by the relevant company over the past approximately 10 years.'
}

const startup = {
    title: 'Startup',
    text:
        'A startup is defined as a company established within 15 years that meets either 1 or 2 (excluding "universities and educational institutions").\n1. For unlisted companies: "total assets of 10 billion yen or less" and "shareholder capital of 5 billion yen or less"\n2. For listed companies: "having conducted an IPO within the past 10 years"'
}

const main_ipc = {
    title: 'Main IPC',
    text:
        'Among the IPCs assigned to the relevant patent application, the IPC with the highest relevance to that patent application is referred to as the "Main IPC". In Intelligent Business Analytics, various analysis processes are performed based on the chief IPC alone.'
}

const bubble_size = {
    title: 'Bubble Size',
    listTitle1: 'Number of Patent Applications',
    listText1: 'The size of the bubble changes in proportion to the number of patent applications.',
    listTitle2: 'Number of Forward Citations',
    listText2: 'The size of the bubble changes in proportion to the number of patent citations.',
    listTitle3: 'Fixed Value',
    listText3: 'All bubbles are displayed at the same size.'
}

const portfolio_bubble_scale = {
    title: 'Bubble Size Emphasis',
    listTitle1: 'Bubble Size Emphasis',
    listText1:
        'Adjusts the intensity of differences in bubble size. Moving left makes smaller bubbles even smaller; moving right makes bubble sizes more uniform.'
}

const portfolio_bubble_size_limit = {
    title: 'Bubble Size Upper Limit',
    listTitle1: 'Bubble Size Upper Limit',
    listText1:
        'Data at or above this value will be displayed as maximum-sized bubbles. Lowering the value makes differences among smaller data points more visible.'
}

const x_axis = {
    title: 'X-axis',
    listTitle1: 'Score (Technological Progress)',
    listText1:
        'The cluster\'s score, which can be interpreted as the "degree of technological progress", is sometimes also referred to as the "technology score". The cluster\'s score is calculated as the sum of the scores of all companies within the relevant cluster, and a higher score indicates a higher degree of technological progress in that cluster (group of technologies).',
    listTitle2: 'Growth Rate of Score',
    listText2:
        "The growth rate of the cluster's score over the past three years, representing the recent speed of technological progress in the relevant cluster (group of technologies). The analysis is conducted by dividing the periods based on the patent application year, and the growth rate of the score is calculated as the average value for each period."
}

const y_axis = {
    title: 'Y-axis',
    listTitle1: 'Market Expectation',
    listText1:
        'Calculated by summing the minority investment amounts (including joint venture investments) each company received within the cluster over the past 10 years, representing the "market attention towards each cluster (group of technologies)".',
    listTitle2: 'Startup Market Expectation',
    listText2:
        'Calculated by summing the minority investment amounts (including joint venture investments) each startup company received within the cluster over the past 10 years, representing the "market attention towards emerging clusters (group of technologies) with startups".',
    listTitle3: 'Growth Rate of Market Expectation',
    listText3:
        'Represents the growth rate of Market Expectation over the past three years, indicating the increase in market attention towards the relevant cluster (group of technologies). Calculated as the average growth rate of Market Expectation for each period, based on the investment year.',
    listTitle4: 'Growth Rate of Startup Market Expectation',
    listText4:
        'Represents the growth rate of startup Market Expectation over the past three years, indicating the increase in market attention towards the relevant cluster (group of technologies). Calculated as the average growth rate of Market Expectation for each period, based on the investment year.',
    listTitle5: 'Business Scale',
    listText5:
        "The total sales of companies within the cluster in the most recent fiscal year, indicating the total business scale of companies holding the relevant cluster's technology."
}

const portfolio_bubble_size = {
    title: 'Bubble Size',
    listTitle1: 'Score (Technological Competitiveness)',
    listText1: `It is the score of the company and can be interpreted as the company's 'technological competitiveness' in the relevant cluster.`,
    listTitle2: 'Number of Patent Applications',
    listText2: `The size of the bubble changes in proportion to the number of patent applications of the company in the relevant cluster.`,
    listTitle3: 'Number of Forward Citations (Average)',
    listText3: `The average number of times the patent applications of a specific company within a relevant cluster are cited in other patent documents by either the applicants or patent examiners. A higher citation count indicates the higher objective importance of the patent application.`,
    listTitle4: 'Number of Material Patents',
    listText4:
        'Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nNumber of Material Patents represents the number of material patents a company holds within the relevant cluster.',
    listTitle5: 'Material Patent Ratio',
    listText5:
        'Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nMaterial Patent Ratio represents the ratio of material patents held by a company to the total number of material patents, within the relevant cluster of the theme.'
}

const portfolio_bubble_size_country = {
    title: 'Bubble Size',
    listTitle1: 'Score (Technological Competitiveness)',
    listText1:
        'A country-level score that can be interpreted as "technological competitiveness," also referred to as "technology score." It is calculated by summing the scores of all companies belonging to the relevant country within a cluster.',
    listTitle2: 'Score (Average)',
    listText2:
        'The average value obtained by dividing the total scores of all companies belonging to the relevant country within a cluster by the number of companies.',
    listTitle3: 'Number of Patent Applications',
    listText3:
        'The total number of patent applications held by all companies belonging to the relevant country within the relevant cluster.',
    listTitle4: 'Citations (Total)',
    listText4:
        'The total number of times patent applications from companies belonging to the relevant country have been cited in other patent documents by applicants or patent examiners. A higher citation count indicates greater objective importance of the patent application.',
    listTitle5: 'Citations Average (Patent-Based)',
    listText5: 'The total citations of companies belonging to the relevant country divided by the number of patents.',
    listTitle6: 'Citations Average (Company-Based)',
    listText6:
        'The average citations of companies belonging to the relevant country divided by the number of companies.',
    listTitle7: 'Citations (Top-N Average)',
    listText7:
        'Companies belonging to the relevant country are ranked by average citations in descending order, and the average is calculated using only the top N% or top N companies. This excludes the influence of companies with low citations and enables comparison of the technological strength of top companies.',
    listTitle8: 'Key Patents',
    listText8:
        'Key patents are defined as patents in the top 5% by citation count within the same IPC classification. Key patent count represents the total number of key patents held by companies belonging to the relevant country within the relevant cluster.',
    listTitle9: 'Key Patent Ratio',
    listText9:
        'Key patents are defined as patents in the top 5% by citation count within the same IPC classification. Key patent ratio represents the proportion of key patents held by companies belonging to the relevant country in the relevant cluster within a theme, divided by the total number of key patents.'
}

const portfolio_x_axis = {
    title: 'X Axis',
    listTitle1: 'Score (Technological Progress)',
    listText1: `The cluster's score, which can be interpreted as the "degree of technological progress", is sometimes also referred to as the "technology score". The cluster's score is calculated as the sum of the scores of all companies within the relevant cluster, and a higher score indicates a higher degree of technological progress in that cluster (group of technologies).`
}

const portfolio_y_axis = {
    title: 'Y Axis',
    listTitle1: 'Market Expectation',
    listText1: `Calculated by summing the minority investment amounts (including joint venture investments) received by each company within the cluster over the past approximately 10 years, representing the "market attention towards each cluster (group of technologies)"`
}

const portfolio_x_axis_country = {
    title: 'X Axis',
    listTitle1: 'Score (Technology Advancement)',
    listText1: `A cluster-level score that can be interpreted as "technology advancement," also referred to as "technology score." The cluster score is calculated by summing the scores of all companies within the relevant cluster; a higher score indicates a greater degree of technology advancement in that cluster (technology group).`
}

const portfolio_y_axis_country = {
    title: 'Y Axis',
    listTitle1: 'Market Expectation',
    listText1: `Calculated by summing the minority investment amounts (including joint venture investments) received by each company within a cluster over approximately the past 10 years. This represents the "level of market attention toward each cluster (technology group)."`
}

const indicative_data = {
    title: 'Indicative Data',
    listTitle1: 'Score',
    listText1:
        'The company\'s score, which can be interpreted as "technological competitiveness", is sometimes also referred to as the "technology score". The cluster\'s score is calculated by summing the scores of all companies within the cluster.',
    listTitle2: 'Number of Patent Applications',
    listText2: 'The number of patent applications held by the company in the relevant cluster.',
    listTitle3: 'Number of Forward Citations (Average)',
    listText3: `The average number of times the patent applications of a specific company within a relevant cluster are cited in other patent documents by either the applicants or patent examiners. A higher citation count indicates the higher objective importance of the patent application.`,
    listTitle4: 'Number of Material Patents',
    listText4:
        'Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nNumber of Material Patents represents the number of material patents a company holds within the relevant cluster.',
    listTitle5: 'Material Patent Ratio',
    listText5:
        'Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nMaterial Patent Ratio represents the ratio of material patents held by a company to the total number of material patents, within the relevant cluster of the theme.'
}

const indicative_data_country = {
    title: 'Indicative Data',
    listTitle1: 'Score (Technological Competitiveness)',
    listText1:
        'A country-level score that can be interpreted as "technological competitiveness," also referred to as "technology score."\nIt is calculated by summing the scores of all companies belonging to the relevant country within a cluster.',
    listTitle2: 'Score (Average)',
    listText2:
        'The average value obtained by dividing the total scores of all companies belonging to the relevant country within a cluster by the number of companies.',
    listTitle3: 'Number of Patent Applications',
    listText3:
        'The total number of patent applications held by companies belonging to the relevant country within the relevant cluster.',
    listTitle4: 'Citations (Total)',
    listText4:
        'The total number of citations across all companies belonging to the relevant country within the relevant cluster. Suitable for understanding the overall scale.',
    listTitle5: 'Citations Average (Patent-Based)',
    listText5: 'The total citations of companies belonging to the relevant country divided by the number of patents.',
    listTitle6: 'Citations Average (Company-Based)',
    listText6:
        'The average citations of companies belonging to the relevant country divided by the number of companies.',
    listTitle7: 'Citations (Top-N Average)',
    listText7:
        'Companies belonging to the relevant country are ranked by average citations in descending order, and the average is calculated using only the top N% or top N companies. This excludes the influence of companies with low citations and enables comparison of the technological strength of top companies.',
    listTitle8: 'Key Patents',
    listText8:
        'Key patents are defined as patents in the top 5% by citation count within the same IPC classification.\nKey patent count represents the total number of key patents held by companies belonging to the relevant country within the relevant cluster.',
    listTitle9: 'Key Patent Ratio',
    listText9:
        'Key patents are defined as patents in the top 5% by citation count within the same IPC classification.\nKey patent ratio represents the proportion of key patents held by companies belonging to the relevant country in the relevant cluster within a theme, divided by the total number of key patents.'
}

const cluster_highlight = {
    title: 'Highlight the cluster.',
    text: 'Highlight the cluster containing patents owned by the selected company.'
}

const company_csv = {
    title: 'Create Company List CSV',
    text:
        'Download information of companies included in the specified cluster ID \nor clusters within the specified domain in CSV format.'
}

const choose_theme = {
    title: 'Select a Theme',
    text: `Intelligent Business Analytics sets themes based on the scope of analysis to be covered from business and technology perspectives.\nFor each theme, patent search queries are pre-defined using IPCs and keywords and its downloaded and processed data is stored in the system. Therefore, users can analyze related technological trends simply by selecting a theme here.`
}

const themes_which_the_company_belongs_to = {
    title: 'Themes which the company belongs to',
    text: `A list of themes that include the selected company's patent applications`
}

const company_patent_count = {
    title: 'Number of patent applications of the company',
    text: `Number of patent applications of the selected company included in the theme.`
}

const company_granted_count = {
    title: 'Number of registered patents of the company',
    text: `Number of registered patents of the selected company included in the theme.`
}

const company_important_count = {
    title: 'Number of material patents of the company',
    text: `Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nIt represents the number of material patents held by the specified company within the theme.`
}

const company_important_ratio = {
    title: 'Percentage of material patents of the company',
    text: `Material patents are defined as the top 5% of patents in terms of citation count within the same IPC.\nIt represents the ratio of material patents held by the specified company to the total number of material patents within the theme.`
}

const company_citation_count = {
    title: 'Number of Forward Citations',
    text: `It represents the number of times the relevant patent application has been cited by the applicant or the patent examiner in other patent documents. It can be said that, the greater the number of citations, the higher the objective importance of that patent application.`
}

const company_patent_ratio = {
    title: 'Percentage of patent applications owned by the specified company',
    text: `Ratio of the number of patent applications filed by the selected company in the theme`
}

const change_cross_vc = {
    title: 'Switch to cross-value chain',
    text:
        'Change the data to the results of IBA analysis conducted across value chains, rather than by each value chain.'
}

const search_conditions_of_theme_list = {
    text: `The system allows for simultaneous selection of multiple search targets, displaying results that meet any of the specified conditions.\nResults shown for keyword and technology classification (IPC) code (in filter options) meet both of the specified conditions.\nHowever, if "Publication Number/Patent Number" is selected, other search target checkboxes will be automatically deselected, and the filter option input field will be disabled.`
}

const cluster_count = {
    title: 'Number of matches for cluster name',
    text: 'Number of clusters within the theme that match the search criteria'
}

const ipc_label_count = {
    title: 'Number of matches for technology classification (IPC) label',
    text: `Number of technology classification (IPC) labels within the theme's clusters that match the search criteria`
}

const ipc_code_count = {
    title: 'Number of matches for technology classification (IPC) code',
    text: `Number of technology classification (IPC) codes within the theme's clusters that match the search criteria`
}

const patent_count = {
    title: 'Number of matches for Patent Applications',
    text: `Number of patent applications within the theme's clusters that match the search criteria`
}

const search_conditions_of_cluster_list = {
    text: `The system allows for simultaneous selection of multiple search targets, displaying results that meet any of the specified conditions.\nResults shown for keyword and technology classification (IPC) code (in filter options) meet both of the specified conditions.\nHowever, if "Publication Number/Patent Number" is selected, other search target checkboxes will be automatically deselected, and the filter option input field will be disabled.\nTitle can be searched only in English regardless of the selected language.`
}

const theme_trends_bubble_size = {
    title: 'Bubble Size',
    listTitle1: 'Number of Patent Applications',
    listText1: 'The size of the bubble changes in proportion to the number of patent applications.'
}

const theme_trends_x_axis = {
    title: 'X Axis',
    listTitle1: 'Patent application growth rate',
    listText1:
        'The patent application growth rate is a value that indicates the average growth rate per year calculated from the cumulative number of applications up to each year.\nIn this system, the application year of the most recent patent registered is considered the latest year, and patent applications from six years ago to one year ago are evaluated in relation to the latest year.'
}

const theme_trends_y_axis = {
    title: 'Y Axis',
    listTitle1: 'Investment growth rate',
    listText1:
        'The patent growth rate is a value that indicates the average growth rate per year calculated from the cumulative number of applications up to each year.\nThe application year of the most recent patent registered in the IBA is considered the latest year, and patent applications from six years ago to one year ago are evaluated in relation to the latest year.',
    listTitle2: 'Total investment amount',
    listText2:
        'The total investment amount refers to the combined value of minority investments (including joint venture investments) received by each company within a theme over the past 10 years. This represents the "level of market attention for each theme."',
    listTitle3: 'Business Scale',
    listText3: 'Business scale refers to the combined value of the revenue amount of each company within a theme.'
}

const patent_applications = {
    title: 'Number of Patent Applications',
    text: 'The number of patent applications held by the company in the relevant cluster.'
}

const growth_rate_patent_application = {
    title: 'Patent application growth rate',
    text:
        'The patent application growth rate is a value that indicates the average growth rate per year calculated from the cumulative number of applications up to each year.\nIn this system, the application year of the most recent patent registered is considered the latest year, and patent applications from six years ago to one year ago are evaluated in relation to the latest year.'
}

const total_investment_amount = {
    title: 'Total investment amount',
    text:
        'The total investment amount refers to the combined value of minority investments (including joint venture investments) received by each company within a theme over the past 10 years. This represents the "level of market attention for each theme."'
}

const investment_growth_rate = {
    title: 'Investment growth rate',
    text:
        'The patent growth rate is a value that indicates the average growth rate per year calculated from the cumulative number of applications up to each year.\nThe application year of the most recent patent registered in the IBA is considered the latest year, and patent applications from six years ago to one year ago are evaluated in relation to the latest year.'
}

const business_scale = {
    title: 'Business Scale',
    text: 'Business scale refers to the combined value of the revenue amount of each company within a theme.'
}

const show_actual = {
    title: 'Show actual values on axes',
    text: 'By default, deviation values are displayed on the axes. Turn this on to also show the actual values.'
}

export const tooltip = {
    link: 'View detailed terminology',
    cluster_id,
    cluster_name,
    score_technological_progress,
    growth_rate_of_score,
    marketability,
    market_attention,
    marketability_startup,
    market_attention_startup,
    ip_code,
    factor_load_quantity,
    is_important,
    most_frequent_ipc,
    score_for_cluster_details,
    important_patents_count,
    important_patent_rate,
    number_of_forward_citations,
    minority_investment_amount,
    startup,
    main_ipc,
    bubble_size,
    x_axis,
    y_axis,
    portfolio_bubble_size,
    portfolio_bubble_size_country,
    portfolio_bubble_scale,
    portfolio_bubble_size_limit,
    portfolio_x_axis,
    portfolio_y_axis,
    portfolio_x_axis_country,
    portfolio_y_axis_country,
    indicative_data,
    indicative_data_country,
    cluster_highlight,
    company_csv,
    choose_theme,
    themes_which_the_company_belongs_to,
    company_patent_count,
    company_granted_count,
    company_important_count,
    company_important_ratio,
    company_citation_count,
    company_patent_ratio,
    change_cross_vc,
    search_conditions_of_theme_list,
    cluster_count,
    ipc_label_count,
    ipc_code_count,
    patent_count,
    search_conditions_of_cluster_list,
    theme_trends_bubble_size,
    theme_trends_x_axis,
    theme_trends_y_axis,
    patent_applications,
    growth_rate_patent_application,
    total_investment_amount,
    investment_growth_rate,
    business_scale,
    show_actual
}
